// demo Comment 29-12-22-01
import { Form, Skeleton } from "antd"
import { toJS } from "mobx"
import { observer } from "mobx-react"
import { Suspense, useEffect, useRef, useState, useLayoutEffect, createRef } from "react"
import "./App.less"
import {
  AppFormBOO,
  Background,
  Benefits,
  Calculator,
  Disclaimer,
  Faq,
  Footer,
  Header,
  IncomePlan,
  KeyTerms,
  MaxReturns,
  PlanWorks,
  Recommended,
  Steps,
  TalkToExpertModal,
  VideoModal,
  WhatIs,
  WhyUs,
  SuitabilityModal,
} from "./Components"
import { mergeByProperty, ScrollToSection, scrollPatch, CreateReactCookie, HideLandingLoader,generateJWTToken, generateSessionToken, } from "./Components/Common/CommonFunctions"
import { QuoteAPI, UserInput } from "./Components/QuoteScreen/QuoteAPI"
import InvestModal from "./Components/Recommended/InvestModal"
import { DataLayerFn, FundAPI, ipAPI, leadWSAPI } from "./Configs/API"
import EditFund from "./Configs/JSON/funds.json"
import AppStore from "./Configs/Store"
import FormStore from "./Configs/Store/forms"
import ModalStore from "./Configs/Store/modals"
import OptionalLeadFrame from "./Components/QuoteScreen/OptionalLeadFrame"
import MythBuster from "./Components/PlanWorks/MythBuster/MythBuster"
import Image from "./Components/Common/Image"
import NewFundLaunch from "./Components/NewFundLaunch/NewFundLaunch"
import { withProviders } from "@ipru-common/components/AemApp"

const SkeletonLoader = ({ children }) => {
  return <Skeleton active />
}

const App = observer(() => {
  const [calcFormRef] = Form.useForm()
  const [quoteFormRef] = Form.useForm()
  const [editFundFormRef] = Form.useForm()
  const [extraCardFormRef] = Form.useForm()

  const calculator = useRef(null)
  const plan = useRef(null)
  const faq = useRef(null)

  useLayoutEffect(() => {
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = "manual"
    }
    window.existing_custo = ""
    const handleResize = async (e) => {
      const width = window.innerWidth
      const height = window.innerHeight
      var isLocalHost = window.location.hostname === "localhost"

      AppStore.setWindowHeight(width)
      AppStore.setWindowWidth(height)
      AppStore.setLocalHost(isLocalHost)

      if (width < 1021) {
        AppStore.setDevice(0)
        window.mobileView = true
      } else {
        AppStore.setDevice(1)
        window.mobileView = false
      }
      if (!isLocalHost) {
        console.log = () => {}
        console.info = () => {}
      }
    }

    const scrollPast = async (e) => {
      var elementTarget = document.getElementsByClassName("GuaranteedIncome_Background")[0]
      if (window.scrollY > elementTarget.offsetTop + elementTarget.offsetHeight) {
        AppStore.setFrameFooter(true)
      } else {
        AppStore.setFrameFooter(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize, { passive: true })
    window.addEventListener("scroll", scrollPast, { passive: true })

    return () => {
      window.removeEventListener("resize", handleResize)
      window.removeEventListener("scroll", scrollPast)
    }
  }, [])

  useEffect(() => {
    if (AppStore.appLoaded) {
      var EmptyScript = window.scriptsLoaded
      var isResume = AppStore.isResumeJourney
      var isStepTrue = new URL(window.location.href).searchParams.get("Step") === "true"
      if (!EmptyScript) {
        const collectIp = async () => {
          const ip = await ipAPI()
          // console.info("IP :", ip)
          AppStore.setIpAddress(ip["origin"])
          window.ipAddress = ip["origin"]
          localStorage.recent_product = "SIGNATURE_dynamic"
        }

        const ScrollToSectionQuery = () => {
          let MAIN_URL = window.location.href
          let URL_OBJ = new URL(MAIN_URL)
          var ScrollTo = URL_OBJ.searchParams.get("scrollTo")
          ScrollToSection(ScrollTo, 0)
        }

        const FundAPICallBack = async () => {
          var fundResp = await FundAPI()

          // var array1 = EditFund["filter"] // EditFund Filter (Base JSON)
          var array2 = [...fundResp] // Data From API (API JSON)
          // var mergedResult = await mergeByProperty(array1, array2, "LAfundCode")

          const latestPolicy = array2?.reduce((latest, current) => {
            return new Date(current?.InceptionDate) > new Date(latest?.InceptionDate)
              ? current
              : latest;
          });

          // add isNew flag to show new label and type to show funds in fund allocation
          const finalArray = array2.map((fund) => {
            const isNewFund = fund?.LAfundCode === latestPolicy?.LAfundCode;
            const typeArray = (fund?.LAfundCode === "CMGF" || fund?.LAfundCode === "INCF") ? [0, 1, 2, 3] : [0, 2];
            return { ...fund, isNew: isNewFund, type: typeArray, tagType: fund?.AssetClass };
          });
          //excluding divider objects
          FormStore.setApi_fundCount(finalArray?.length);
          // used to maintain existing ui
          const divider1 = EditFund.filter.find(fund => fund?.LAfundCode === "X_1001_X");
          const divider2 = EditFund.filter.find(fund => fund?.LAfundCode === "X_1002_X");

          if (divider1) finalArray.push(divider1);
          if (divider2) finalArray.push(divider2);

          FormStore.setAPIFundPerform(finalArray);
          FormStore.setAPIFundPerform_UNTOUCHED(finalArray);
        }

        if (!isStepTrue) {
          setTimeout(HideLandingLoader, isResume ? 2500 : 1000)
        }

        FundAPICallBack()
        collectIp()
        MessageListener()

        DataLayerFn("Landed||Calculator-Landing page", FormStore, "", "", "", "")
        setTimeout(ScrollToSectionQuery, 150)

        window.scriptsLoaded = true
      }
    }
    setTimeout(() => {
      if (typeof window.hj === "function") {
        // window.hj =
        //   window.hj ||
        //   function () {
        //     (window.hj.q = window.hj.q || []).push(arguments)
        //   }
        // window.hj("event", "sandg_lp")
        // console.log("hotjar app.js landing")
      }
    }, 1000)
  }, [AppStore.appLoaded])

  useEffect(() => {
    const jwtFunction = async () => {
      return;
      console.log(AppStore.isTesting, "testing Line")
      let iSUat = window.location.href.includes("testing") && !window.location.href.includes("api=prod")
      let jwtToken = await generateJWTToken(iSUat,true)
      await generateSessionToken(jwtToken, iSUat)
      console.log("calc jwt", jwtToken)
    }
    jwtFunction()
  }, [])


  const QuoteAPIFn = async (lifeCoverFlag) => {
    await FormStore.setQuoteCardLoader(true)
    var response = await QuoteAPI(FormStore, calcFormRef, quoteFormRef, editFundFormRef, extraCardFormRef, lifeCoverFlag, false) // false = SalesChannel 7 & Mode ON
    if (response["PremiumSummary"] !== undefined && response["Illustration"]) {
      var PurchaseAnnuity10 = response["PremiumSummary"]["PurchaseAnnuity10"]
      var PurchaseAnnuity6 = response["PremiumSummary"]["PurchaseAnnuity6"]

      var responseOffline = await QuoteAPI(FormStore, calcFormRef, quoteFormRef, editFundFormRef, extraCardFormRef, lifeCoverFlag, true) // true = SalesChannel 2 & Mode OF
      if (responseOffline["PremiumSummary"] !== undefined && responseOffline["Illustration"] !== undefined) {
        var PurchaseAnnuity10_Offline = responseOffline["PremiumSummary"]["PurchaseAnnuity10"]
        var PurchaseAnnuity6_Offline = responseOffline["PremiumSummary"]["PurchaseAnnuity6"]

        FormStore.setAPI8PercentageOFFLINE(PurchaseAnnuity10_Offline)
        FormStore.setAPI4PercentageOFFLINE(PurchaseAnnuity6_Offline)
      } else {
        FormStore.setAPI8PercentageOFFLINE(0)
        FormStore.setAPI4PercentageOFFLINE(0)
      }
      // Since useEffect is Used over their state. offline becomes 0. // Fixse negative Values possiblity
      FormStore.setAPI8Percentage(PurchaseAnnuity10)
      FormStore.setAPI4Percentage(PurchaseAnnuity6)
      UserInput("OutputObjHold_4", PurchaseAnnuity6, "", "")
      UserInput("OutputObjHold_8", PurchaseAnnuity10, "", "")
    }

    CreateReactCookie()
    await FormStore.setQuoteCardLoader(false)
  }

  const MessageListener = () => {
    window.onmessage = (e) => {
      var SuitParent = e.data.SuitParent
      var SuitDataLayer = e.data.DataLayer
      var OptionalLead = e.data.OptionalLead

      if (SuitParent || SuitDataLayer || OptionalLead) {
        console.info("onMessage :", e.data)
      }

      // Suitabiltiy
      if (SuitParent) {
        if (SuitParent["closeSuitability"]) {
          FormStore.setSuitabilityModal(false)
          if (!FormStore.quote_modal) {
            // Patch Scroll Issue Only In Landing Page
            scrollPatch("auto")
          }
          console.info("Window Closed", SuitParent)
        } else {
          var element = document.querySelector(".SuitabilityModalRoot .ant-modal-content")
          if (element) {
            console.info("Message :", SuitParent)
            element.style.height = SuitParent.height + 80 + "px"
          }
        }
        if (SuitParent["fireLeadWS"]) {
          const leadRes = leadWSAPI(FormStore, SuitParent["SuitabilityCheckBox"])
        }
      }

      // Suitabiltiy Data Layer
      if (SuitDataLayer && SuitDataLayer["eventName"] !== "SuitabilityCalculator_PopupSeen") {
        DataLayerFn(`${SuitDataLayer["eventName"]} || ${SuitDataLayer["sectionName"]}`, FormStore, "", SuitDataLayer["buttonText"], SuitDataLayer["optionSelected"], {
          SuitabilityCalculation: SuitDataLayer["SuitabilityCalculation"],
        })
      }

      // Optional Lead
      if (OptionalLead) {
        var EmailVal = OptionalLead["emailItem"]
        var MobileVal = OptionalLead["mobileItem"]
        if (EmailVal && MobileVal) {
          FormStore.setOptionalLead(false)
          FormStore.setCalcEmail(EmailVal)
          FormStore.setCalcPhone(MobileVal)
          calcFormRef.setFieldsValue({ emailItem: EmailVal })
          calcFormRef.setFieldsValue({ mobileItem: MobileVal })
          UserInput("EmailId", EmailVal, "")
          UserInput("MobileNo", MobileVal, "")
          const leadRes = leadWSAPI(FormStore)
          DataLayerFn("OptionalLead_Continue||Calculator-QuoteScreen|Optional Lead Popup", FormStore, "", "Continue", "", "")
          DataLayerOptionEvent()
        }
      }
    }
  }

  const DataLayerOptionEvent = () => {
    var Email = window.ReactOptionLead_Email
    var Mobile = window.ReactOptionLead_Mobile
    if (!Email && !Mobile) {
      DataLayerFn("LeadSubmitted_MandatoryPopUp||Calculator-QuoteScreen|Mandatory Popup", FormStore, "", "", "", "")
    } else if (!Email) {
      DataLayerFn("EmailSubmitted_MandatoryPopUp||Calculator-QuoteScreen|Mandatory Popup", FormStore, "", "", "", "")
    } else if (!Mobile) {
      DataLayerFn("LeadSubmitted_Mobile_MandatoryPopUp||Calculator-QuoteScreen|Mandatory Popup", FormStore, "", "", "", "")
    }
  }

  return (
    <>
      <Header type={0} />
      <InvestModal
        component={
          <>
            {ModalStore.invest_calc_quote && (
              <>
                <div className="head">
                  <div className="title1">INVEST NOW. SAVE BIG.</div>
                  <div className="title2">Please confirm your details</div>
                </div>
                <div className="App_Matrix">
                  {" "}
                  <Calculator calcFormRef={calcFormRef} QuoteAPI={QuoteAPIFn} />
                </div>
              </>
            )}
          </>
        }
        calcFormRef={calcFormRef}
      />

      <Background>
        <div className="IncomeMain">
          <div className="IncomeRoot">
            <IncomePlan />
            <Suspense fallback={<SkeletonLoader />}>
              <Benefits />
            </Suspense>
            <div className="IncomeConditions">
              <sup>1</sup>Conditions apply
            </div>
          </div>
        </div>
        <div ref={calculator}>
          <Calculator calcFormRef={calcFormRef} quoteFormRef={quoteFormRef} QuoteAPI={QuoteAPIFn} />
        </div>
      </Background>
      {/* <Suspense fallback={<SkeletonLoader />}>
        <QuoteModal quoteFormRef={quoteFormRef} editFundFormRef={editFundFormRef} extraCardFormRef={extraCardFormRef} QuoteAPI={QuoteAPIFn} />
      </Suspense> */}
       <Suspense fallback={<div>Loading New Fund Launch...</div>}>
        <NewFundLaunch isSticky={false} />
      </Suspense>

      <Suspense fallback={<div>Loading New Fund Launch...</div>}>
        <NewFundLaunch isSticky={true} />
      </Suspense>
      <Suspense fallback={<SkeletonLoader />}>
        <AppFormBOO />
      </Suspense>
      <Suspense fallback={<SkeletonLoader />}>
        <Recommended calculatorRef={calculator} quoteFormRef={quoteFormRef} />
      </Suspense>
      <Suspense fallback={<SkeletonLoader />}>
        <WhatIs />
      </Suspense>
      <div ref={plan}>
        <Suspense fallback={<SkeletonLoader />}>
          <PlanWorks calculatorRef={calculator} calcFormRef={calcFormRef} />
        </Suspense>
        <Suspense fallback={<SkeletonLoader />}>
          <VideoModal />
        </Suspense>
      </div>

      <Suspense fallback={<SkeletonLoader />}>
        <MaxReturns />
      </Suspense>
      <Suspense fallback={<SkeletonLoader />}>
        <Steps />
      </Suspense>
      <Suspense fallback={<SkeletonLoader />}>
        <WhyUs />
      </Suspense>
      {/* {App.device === 1 ? (
        <>
          <Suspense fallback={<SkeletonLoader />}>
            <Steps />
          </Suspense>
          <Suspense fallback={<SkeletonLoader />}>
            <WhyUs />
          </Suspense>
        </>
      ) : (
        <>
          <Suspense fallback={<SkeletonLoader />}>
            <WhyUs />
          </Suspense>
          <Suspense fallback={<SkeletonLoader />}>
            <Steps />
          </Suspense>
        </>
      )} */}

      <div ref={faq}>
        <Suspense fallback={<SkeletonLoader />}>
          <Faq />
        </Suspense>
      </div>
      {/* <Suspense fallback={<SkeletonLoader />}>
        <KeyTerms />
      </Suspense> */}
      {AppStore.device === 0 && <div className="Disclaimer_DividerMob" />}
      <Suspense fallback={<SkeletonLoader />}>
        <Disclaimer data={"main"} type={0} personaType={FormStore.calc_type["key"]} />
      </Suspense>
      {/* <Suspense fallback={<SkeletonLoader />}>
        {AppStore.device === 1 && <MythBuster calculatorRef={calculator} />}
      </Suspense> */}
      <Suspense fallback={<SkeletonLoader />}>
        <Footer calculatorRef={calculator} planRef={plan} faqRef={faq} />
      </Suspense>
      <Suspense fallback={<SkeletonLoader />}>
        <OptionalLeadFrame calcFormRef={calcFormRef} />
      </Suspense>

      <Suspense fallback={<SkeletonLoader />}>
        <TalkToExpertModal />
      </Suspense>

      <Suspense fallback={<SkeletonLoader />}>
        <SuitabilityModal />
      </Suspense>
    </>
  )
})

export default withProviders(App)